import { parse as _parse } from 'qs';
import { isUndefined } from 'lodash';

function stringify(queryString) {
  if (!queryString) {
    return '';
  }
  if (typeof queryString === 'string') {
    return queryString;
  }
  const searchParams = new URLSearchParams();
  Object.entries(queryString).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => !isUndefined(v) && searchParams.append(key, v));
    } else {
      !isUndefined(value) && searchParams.append(key, value);
    }
  });
  return searchParams.toString();
}

function parse(queryString) {
  return _parse(queryString?.substr(1));
}

export default {
  stringify,
  parse,
};
